/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { getImageProductByCode } from '~/helpers/products';
import { CheckboxWithContent } from '~/elements';
import If from '~/components/If';
import { updateResposta } from '~/store/modules/indicacao/actions';

const StyledCheckbox = styled(CheckboxWithContent)`
  margin: 5px 0 20px 0;
  img {
    width: 60px;
    margin-right: 20px;
  }
`;

const Legend = styled.legend`
  span {
    color: ${({ theme }) => theme.colors.gray400};
    font-size: 1rem;
  }
  ${({ invalid, theme }) =>
    invalid &&
    css`
      margin-bottom: 0 !important;
      color: ${theme.colors.danger} !important;
      span {
        color: ${theme.colors.danger} !important;
      }
    `}
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
`;
const MessageError = styled.p`
  color: #fff;
  font-size: 0.66rem;
  padding: 3px 6px;
  background: #e32525;
  margin-top: 1rem;
`;

export default function Pergunta({
  code,
  label,
  type,
  products,
  question,
  required,
  showError,
  hasRespostaPadrao,
  respostaPadrao,
}) {
  const dispatch = useDispatch();
  const [resposta] = useSelector(state =>
    state.indicacao.respostas.filter(item => item.codigo === code),
  );
  const selectedProducts = (resposta && resposta.produtos) || [];
  const [hasError, setHasError] = useState(required && showError);

  useEffect(() => {
    setHasError(required && showError);
  }, [required, showError]);

  function validate(selecionados) {
    if (required) {
      setHasError(selecionados.length === 0);
    }
  }

  function onChangeCheckbox(e) {
    const { target } = e;
    let newProducts = [];

    if (target.checked) {
      newProducts = [target.value, ...selectedProducts];
    } else {
      newProducts = selectedProducts.filter(sigla => sigla !== target.value);
    }
    validate(newProducts);
    dispatch(updateResposta(code, newProducts, required));
  }

  function renderCheckbox({ codigo, siglaProduto, descricaoProduto }) {
    const codigoFormatado = String(codigo).padStart(5, '0');
    const img = getImageProductByCode(codigoFormatado);
    const disabled = selectedProducts.indexOf(respostaPadrao) >= 0;

    return (
      <StyledCheckbox
        key={`product-${type}-${siglaProduto}`}
        value={siglaProduto}
        onChange={onChangeCheckbox}
        disabled={disabled}
        checked={selectedProducts.indexOf(siglaProduto) >= 0}
      >
        {img && <img src={img} alt={descricaoProduto} />}
        {descricaoProduto}
      </StyledCheckbox>
    );
  }

  return (
    <fieldset className="pergunta-indicacao-ec">
      <Legend invalid={hasError}>
        <span>
          {question} - {label}
        </span>
      </Legend>
      {hasError && (
        <MessageError>Selecione pelo menos uma das opções abaixo.</MessageError>
      )}
      <Content>
        {products.map(prod => renderCheckbox(prod))}

        <If test={hasRespostaPadrao}>
          <StyledCheckbox
            id="resposta-padrao"
            value={respostaPadrao}
            onChange={onChangeCheckbox}
            disabled={
              selectedProducts.length > 0 &&
              selectedProducts.indexOf(respostaPadrao) === -1
            }
            checked={selectedProducts.indexOf(respostaPadrao) >= 0}
          >
            {respostaPadrao}
          </StyledCheckbox>
        </If>
      </Content>
    </fieldset>
  );
}

Pergunta.propTypes = {
  code: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['PRODUTO_ATIVO', 'PRODUTO_INATIVO', 'TODOS_PRODUTOS'])
    .isRequired,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      codigo: PropTypes.string.isRequired,
      descricaoProduto: PropTypes.string.isRequired,
      siglaProduto: PropTypes.string.isRequired,
    }),
  ).isRequired,
  question: PropTypes.number.isRequired,
  required: PropTypes.bool,
  showError: PropTypes.bool,
  hasRespostaPadrao: PropTypes.bool,
  respostaPadrao: PropTypes.string,
};

Pergunta.defaultProps = {
  required: false,
  showError: false,
  hasRespostaPadrao: false,
  respostaPadrao: '',
};
